<ppl-checkbox *ngFor="let option of normalizedOptions; trackBy: trackByValue"
              #checkbox="pplCheckbox"
              [disabled]="disabled"
              [value]="!!value && value.includes(option.value)"
              [autofill]="changes.includes(option.value)"
              (valueChange)="onCheck(option.value, $event.checked)">
  <span [class.changes]="checkbox.autofill"
        class="label">{{option.label}}</span>
</ppl-checkbox>
